export const PACKAGES = [
  { key: "monthly", label: "Monthly", months: 1, price: 3750 },
  { key: "quarterly", label: "Quarterly", months: 3, price: 10500 },
  { key: "half_yearly", label: "Half-Yearly", months: 6, price: 19500 },
  { key: "annual", label: "Annual", months: 12, price: 36000 },
];

export const packageByKey = (k) => PACKAGES.find((p) => p.key === k);

const addMonths = (iso, n) => {
  const [y, m, d] = iso.split("-").map(Number);
  const last = new Date(Date.UTC(y, m - 1 + n + 1, 0)).getUTCDate();
  return new Date(Date.UTC(y, m - 1 + n, Math.min(d, last)));
};

const fmt = (dt) => dt.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
export const fmtIso = (iso) => (iso ? fmt(new Date(`${iso}T00:00:00Z`)) : "");

export const packagePeriod = (key, start) => {
  const pkg = packageByKey(key);
  if (!pkg || !start) return null;
  const renew = addMonths(start, pkg.months);
  const end = new Date(renew.getTime() - 86400000);
  return { from: fmtIso(start), to: fmt(end), renews: fmt(renew) };
};
